import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useParams} from 'react-router-dom';

import {useDeleteBankAccountsMutation} from '../hooks/useBankAccountsQuery';

interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

/**
 * FNP-918: batch delete, through the shared confirmation button (§2).
 *
 * Now takes the mutation directly instead of instantiating the whole
 * `useBankAccounts` list hook. The old version called
 * `useBankAccounts(customerId)` purely to reach `deleteRecords`, which mounted
 * a SECOND copy of the list query inside the page header — a duplicate fetch on
 * every render of a button.
 *
 * It is disabled rather than throwing when no customer is in scope; a header
 * button that throws takes the whole page down.
 */
export const DeleteRecordButton = ({
                                       selectedIds,
                                       onDeleteComplete,
                                   }: DeleteRecordButtonProps) => {

    const params = useParams();
    const customerId = params.customerId || params.id;

    const deleteMutation = useDeleteBankAccountsMutation(customerId ?? '');

    const disabled = selectedIds.length === 0
        || !customerId
        || deleteMutation.isPending;

    return (
        <DeleteRecordsConfirmationButton
            disabled={disabled}
            recordIdsLength={selectedIds.length}
            handleConfirm={() => {
                deleteMutation.mutate(selectedIds);
                onDeleteComplete?.();
            }}
        />
    );
};
